import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';

export default class TpPaymentRequestStatusChangeSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    EntityId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    if (!this.props.EntityId) {
      this.setState({ selectValues: [] });
      return;
    }

    ThirdPartyJobPaymentsService.GetAvailableStatusNavigationActions(this.props.EntityId)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((paymentRequest) => {
          optValues.push({
            label: `${paymentRequest.name}`,
            value: paymentRequest.id,
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TPRSCS47');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
